import { Box } from '@mui/material';

const ConsentHomeBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        padding: {
          xs: '16px 24px',
          sm: '24px 32px',
          md: `24px 48px`,
        },

        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',

        color: '#021E38',
        backgroundColor: '#FCF7F0',
      }}
    >
      {children}
    </Box>
  );
};

export default ConsentHomeBody;
